import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User viewed the checkout page',
  name: 'Viewed checkout page',
  params: [
    {
      description: 'Type of checkout',
      name: 'mode',
      required: true,
      type: 'enum',
      values: ['purchase', 'plan-upgrade', 'credit-pack-upgrade'],
    },
    {
      description: 'Current subscription plan of the user',
      name: 'plan',
      required: true,
      type: 'string',
    },
    {
      description: 'Subscription plan the user is moving to (if plan upgrade)',
      name: 'new_plan',
      required: false,
      type: 'string',
    },
    {
      description: 'Credit pack quantity (if credit pack upgrade)',
      name: 'pack_quantity',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
